export default __webpack_public_path__ + "static/media/slot.b26d6a28.png";